import { DeviceEventEmitter } from "react-native";
import { useEffect } from "react";

const useResetFilter = (resetFunction: any) => {
  useEffect(() => {
    const eventListener = DeviceEventEmitter.addListener(
      "RESET_FILTERS_EVENT",
      () => {
        resetFunction?.();
      }
    );

    return () => {
      eventListener.remove();
    };
  }, []);
};

export default useResetFilter;
